import type { Dispatch, SetStateAction } from "react";

import type { ConnectionStatusResponse } from "@hz/common/api-types/auth";
import type { OurStages } from "@hz/common/constants";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Flex, VStack } from "@chakra-ui/react";

import OAuthConnector from "@components/oauth-connector";
import { Button } from "@components/ui/button";

import { fetchInit } from "@state/mondaySlice";
import type { AppDispatch } from "@state/store";

type ConnectionStepProps = {
  stage: OurStages | null;
  data?: {
    isMondayConnected: boolean;
  };
  isLoading: boolean;
  setStep: Dispatch<SetStateAction<number>>;
  isMondayConnected?: boolean;
};

const MondayConnectionStep = ({
  stage,
  data,
  setStep,
  isLoading,
  isMondayConnected,
}: ConnectionStepProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const onOauthConnect = async () => {
    await dispatch(fetchInit({ forceRefetch: true }));

    if (isMondayConnected) {
      setStep(1);
    }
  };

  const onOauthDisconnect = async () => await dispatch(fetchInit({ forceRefetch: true }));

  return (
    <>
      <VStack
        align="flex-start"
        w="full"
        alignSelf="center"
        gapY={"24px"}
      >
        <OAuthConnector
          type="monday"
          data={{ isMondayConnected: Boolean(isMondayConnected), isGoogleConnected: true }}
          isLoading={false}
          oAuthCallback={onOauthConnect}
          oAuthDisconnectCallback={onOauthDisconnect}
        />
      </VStack>
      <Flex
        justifyContent="flex-end"
        width="100%"
        mt="24px"
      >
        <Button
          colorPalette="blue"
          onClick={onOauthConnect}
          loading={isLoading}
          disabled={!isMondayConnected}
        >
          Continue
        </Button>
      </Flex>
    </>
  );
};

export default MondayConnectionStep;
